export type CombinationRuleOperator = "lt" | "lte" | "gt" | "gte" | "eq";

export const COMBINATION_RULE_OPERATORS: CombinationRuleOperator[] = [
  "lt",
  "lte",
  "gt",
  "gte",
  "eq",
];

export const COMBINATION_RULE_OPERATOR_SIGNS: Record<
  CombinationRuleOperator,
  string
> = {
  lt: "<",
  lte: "≤",
  gt: ">",
  gte: "≥",
  eq: "=",
};

export type CombinationRuleConditionType =
  | "posts"
  | "category"
  | "annual_plan"
  | "monthly_new_car_sales"
  | "forecast_car_visits";

export const COMBINATION_RULE_CONDITION_TYPES: CombinationRuleConditionType[] =
  [
    "posts",
    "category",
    "annual_plan",
    "monthly_new_car_sales",
    "forecast_car_visits",
  ];

export type CombinationRuleConditionOperator = "<" | ">" | "=" | "<=" | ">=";

export const COMBINATION_RULE_CONDITION_OPERATORS: CombinationRuleConditionOperator[] =
  ["<", ">", "=", "<=", ">="];

export interface ICombinationRuleCondition {
  id: string;
  conditionType: CombinationRuleConditionType;
  isActive: boolean;
  postIds: number[] | null;
  operator: CombinationRuleConditionOperator | null;
  value: number | null;
  category: number[] | null;
  sortOrder: number;
}

export interface ICombinationRuleGroupDealer {
  id: string;
  dealerId: number;
  dealerName: string;
}

export interface ICombinationRuleGroup {
  id: string;
  name: string | null;
  isActive: boolean;
  sortOrder: number;
  dealerIds: number[];
  dealers: ICombinationRuleGroupDealer[];
  conditions: ICombinationRuleCondition[];
}

export interface ICombinationRule {
  id: string;
  mainPositionId: number;
  additionalPositionIds: number[];
  rolePositionIds: number[];
  groups: ICombinationRuleGroup[];
  postIds: number[];
  operator: CombinationRuleOperator;
  maxPosts: number;
  isActive: boolean;
  actualFrom: string | null;
  actualTo: string | null;
  maxPerEmployee: number | null;
  description: string | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CombinationRulesResponse {
  items: ICombinationRule[];
  total: number;
}

export interface ICombinationRulePrecheckRecord {
  employeeFio: string;
  dealerName: string;
  position: string;
  message: string;
}

export interface ICombinationRulePrecheckDealer {
  dealerId: number;
  dealerName: string;
  records: ICombinationRulePrecheckRecord[];
}

export interface CombinationRulesPrecheckResponse {
  checked: number;
  rejected: number;
  dealers: ICombinationRulePrecheckDealer[];
  errors: unknown[];
}

export type CombinationRuleOrderBy =
  | "createdAt"
  | "updatedAt"
  | "mainPositionId"
  | "maxPosts"
  | "operator"
  | "isActive"
  | "createdBy"
  | "updatedBy";

export interface IParamsCombinationRules {
  /** 1-based (по контракту бэкенда). */
  page?: number;
  count?: number;
  mainPositionId?: number;
  additionalPositionId?: number;
  rolePositionId?: number;
  dealerId?: number;
  conditionTypes?: CombinationRuleConditionType[];
  createdBy?: string;
  updatedBy?: string;
  /** Строкой, как в swagger: "true" | "false". */
  isActive?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
  orderBy?: CombinationRuleOrderBy;
  orderDirection?: "asc" | "desc";
}

export interface CombinationRuleConditionPostSchema {
  conditionType: CombinationRuleConditionType;
  /** Только для conditionType="posts". */
  postIds?: number[];
  /** Для всех типов, кроме "category". */
  operator?: CombinationRuleConditionOperator;
  /** Для всех типов, кроме "category". */
  value?: number;
  /** Только для conditionType="category" (0-3). */
  category?: number[];
  isActive?: boolean;
  sortOrder?: number;
}

export interface CombinationRuleGroupPostSchema {
  name?: string;
  isActive?: boolean;
  sortOrder?: number;
  dealerIds: number[];
  conditions: CombinationRuleConditionPostSchema[];
}

export interface CombinationRulePostSchema {
  mainPositionId: number;
  additionalPositionIds: number[];
  rolePositionIds?: number[];
  groups: CombinationRuleGroupPostSchema[];
  isActive?: boolean;
  actualFrom?: string | null;
  actualTo?: string | null;
  maxPerEmployee?: number;
  description?: string;
}

export type CombinationRulePutSchema = CombinationRulePostSchema;

export interface IPlacePostType {
  id: number;
  name: string;
  nameEn: string;
}

/** Ответ /place-posts/types: { data: [...] }; оставлены фолбэки на другие обёртки. */
export type PlacePostTypesResponse =
  | { data: IPlacePostType[] }
  | IPlacePostType[]
  | { items: IPlacePostType[] };

export interface IRuleFilterDealer {
  id: number;
  name: string;
}

export interface IRuleFilterPosition {
  id: number;
  name: string;
  code?: string;
}

export type RuleFilterCategoriesResponse = number[];
